export default __webpack_public_path__ + "static/media/about.4b3b945e.png";